export default __webpack_public_path__ + "static/media/3Y.60a855f1.png";